import { Pipe, PipeTransform } from '@angular/core';

import { PessoaContatoTipo } from '../pessoa-contato-tipo';

@Pipe({
    name: 'pessoaContatoTipoSort'
})
export class PessoaContatoTipoSortPipe implements PipeTransform {
    transform(tipos: PessoaContatoTipo[]): PessoaContatoTipo[] {
        if (!tipos) {
            return [];
        }

        return tipos.sort((tipoA, tipoB) => tipoA.nome.toUpperCase() < tipoB.nome.toUpperCase() ? -1 : 1);
    }
}
